import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import request from '../lib/request';

const useAuth = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof window === 'object') {
      requestUser();
    }
  }, []);

  const requestUser = async () => {
    setLoading(true);
    try {
      if (request.sid) {
        const { result } = await request.get('/user');

        if (!result) {
          setUser({});
          throw new Error('Invalid user');
        }

        setUser(result);
      }
    } catch (err) {
      console.log(err?.message);
    } finally {
      setLoading(false);
    }
  };

  const signIn = async (email, password) => {
    try {
      setLoading(true);
      if (email && password) {
        const { result } = await request.post('/signin', {
          email,
          password,
        });
        if (result?.sid) {
          window.localStorage.setItem('SID', result.sid);
          request.setSid(result.sid);
          navigate('/dashboard');
        }

        return;
      }

      throw new Error('Invalid email or password');
    } catch (err) {
      if (err?.response?.data?.error) {
        alert(err?.response?.data?.error);
      } else {
        alert(err?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      window.localStorage.removeItem('fcmToken');
      await request.delete(`/user/device-token`);
    } catch (err) {
      console.log(err?.message);
    }

    try {
      window.localStorage.removeItem('SID');
      window.localStorage.removeItem('fcmToken');

      await request.delete('/signout');
      setUser(null);
    } catch (err) {
      console.log(err?.message);
    }
  };

  return { loading, user, signIn, signOut, refreshUser: requestUser };
};

export default useAuth;
